import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { getInvitation} from 'store/actions/onboarding-actions';
import InvitationWaitlist from './invitation-waitlist';

function Invitation(){

  const dispatch = useDispatch();
  const classes = useStyles();
  const [code, setCode]= useState("");
  const [isWaitlisting, setWaitlisting] = useState(false);
  const invError = useSelector(state => state.onboarding.invitationError);

  const onSubmit = async () => {
    console.log("validating invitation code: ", code)
    const myCode  = code.trim();
    if(myCode){
      return dispatch(getInvitation(myCode));
    }
  };

  const buttonStyle   = code && code.length >= 4 ? "contained" : "outlined";

  return (
    <Grid container justifyContent="center">
      <Grid item sm={12} container justifyContent="center">
        <Typography className={classes.info}>FormHop is currently available by invitation only.  Enter your invitation code to begin.</Typography>
      
        <Grid item sm={9} container justifyContent="flex-start">
          <TextField id="invitationCode" value={code} onChange={(e) => setCode(e.target.value)} label="Invitation Code" variant="standard" fullWidth/>
        </Grid>
        <Grid item sm={3} container justifyContent="flex-end" className={classes.btnRow}>
          <Button variant={buttonStyle} color="primary" onClick={() => onSubmit(code)}>Submit</Button>
        </Grid>
      
        {invError && 
          <Card elevation={0} className={classes.errorCard} variant="outlined">
            <span>{invError.message}</span>
          </Card>
        }
      </Grid>

      <Grid item sm={12} container justifyContent="flex-start" className={classes.bottomRow}>
        <Typography className={classes.info}>Need an invitation?</Typography>
        <Button className={classes.linkButton} color="primary" onClick={() => setWaitlisting(!isWaitlisting)}>Click here.</Button>
        { isWaitlisting &&  <InvitationWaitlist isOpen={isWaitlisting} /> }          
      </Grid>
    </Grid>
  );
}

export default Invitation;

const useStyles  = makeStyles(theme => ({
  root      : {
    padding       : `${theme.spacing(2)} ${theme.spacing(1)}`,
  }, 
  info      : {
    marginBottom  : theme.spacing(1),
    fontSize      : 18,
    fontWeight    : 300,
    color         : theme.palette.grey[600],
  },   
  btnRow    : {
    marginTop     : theme.spacing(2),
  },
  bottomRow   : {
    marginTop     : theme.spacing(8),
  },
  linkButton  : {
    border    : "none",
    fontSize  : 18,
    fontWeight: 300,
    color     : theme.palette.primary.main,
    padding   : 0,
    marginLeft: theme.spacing(1),
    marginTop : theme.spacing(-1),
    textTransform : "lowercase",
  },
  errorCard         : {
    background      : theme.palette.error.light,
    border          : `1px solid ${theme.palette.error.dark}`,
    borderRadius    : 5,
    color           : theme.palette.error.main,
    margin          : "10px 0",
    padding         : "2.5px 5px",
    position        : "relative",
    width           : "100%",
  }, 
  
}));